import { Navigate, Route, Routes, useLocation } from "react-router";
import { useAuth } from "./auth/AuthContext";
import { RequireAuth } from "./auth/RequireAuth";
import { AcceptInvitePage } from "./routes/AcceptInvitePage";
import { DwbPage } from "./routes/DwbPage";
import { ForgotPasswordPage } from "./routes/ForgotPasswordPage";
import { HomePage } from "./routes/HomePage";
import { InvitePage } from "./routes/InvitePage";
import { LoginPage } from "./routes/LoginPage";
import { OAuthConsentPage } from "./routes/OAuthConsentPage";
import { PlanningEnhancedPage } from "./routes/PlanningEnhancedPage";
import { PreplanningPage } from "./routes/PreplanningPage";
import { ReportPage } from "./routes/ReportPage";
import { ResetPasswordPage } from "./routes/ResetPasswordPage";

function RootRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <main className="panel">
        <p>Autorisatie controleren...</p>
      </main>
    );
  }
  return <Navigate to={user ? "/home/" : "/login/"} replace />;
}

export function App() {
  const { passwordRecovery } = useAuth();
  const location = useLocation();

  if (passwordRecovery && location.pathname !== "/reset-password/") {
    return <Navigate to="/reset-password/" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<RootRoute />} />
      <Route path="/login/" element={<LoginPage />} />
      <Route path="/forgot-password/" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/" element={<ResetPasswordPage />} />
      <Route
        path="/home/"
        element={
          <RequireAuth>
            <HomePage />
          </RequireAuth>
        }
      />
      <Route
        path="/reports/"
        element={
          <RequireAuth>
            <ReportPage />
          </RequireAuth>
        }
      />
      <Route
        path="/preplanning/"
        element={
          <RequireAuth>
            <PreplanningPage />
          </RequireAuth>
        }
      />
      <Route
        path="/dwb/"
        element={
          <RequireAuth>
            <DwbPage />
          </RequireAuth>
        }
      />
      <Route
        path="/planning/"
        element={
          <RequireAuth>
            <PlanningEnhancedPage />
          </RequireAuth>
        }
      />
      <Route
        path="/invite/"
        element={
          <RequireAuth>
            <InvitePage />
          </RequireAuth>
        }
      />
      <Route path="/oauth/consent" element={<OAuthConsentPage />} />
      <Route path="/oauth/accept-invite" element={<AcceptInvitePage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
